import React from "react";
import { Link } from "react-router-dom";

const LOGO_URL = "https://media.base44.com/images/public/6a460432963500ce22897197/dbcb3066e_Primarylogo_.png";

export default function Logo({ className = "", imgClassName = "" }) {
  return (
    <Link to="/" className={`inline-flex items-center ${className}`}>
      <img
        src={LOGO_URL}
        alt="Digital24"
        width="129"
        height="28"
        decoding="async"
        className={`h-7 lg:h-8 w-auto ${imgClassName}`}
      />
    </Link>
  );
}